import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ContabilizzazioniService {

  static getContabilizzazioniByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/contabilizzazioni/find`;
      ApiService.postRudeRequest(resolve, reject, url, params)
  });
  };

  static createContabilizzazione = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/contabilizzazioni/contabilizza`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

}
